// extracted by mini-css-extract-plugin
export default {"badge":"video_badge__OEDad"};